import { gql } from '@apollo/client';

export const GET_BLACKLIST_DOMAIN_CSV = gql`
  query getBlacklistDomainCSV($input: CheckSettingsInput) {
    getBlacklistDomainCSV(input: $input) {
      csv
    }
  }
`;
